import React, {Component} from 'react';
import PropTypes from 'prop-types';

class SkipToContentMenuAnchorInner extends Component {
    static propTypes = {
        menuItemLabel: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        order: PropTypes.number,
        anchorLabel: PropTypes.string
    }

    static defaultProps = {
        order: 0,
        addMenuItem: () => {},
        removeMenuItem: () => {}
    }

    componentDidMount() {
        const {menuItemLabel: label, id, order, addMenuItem} = this.props;

        addMenuItem({label, id, order});
    }

    componentWillUnmount() {
        this.props.removeMenuItem(this.props.id);
    }

    render() {
        const {children, id, anchorLabel} = this.props;

        if (this.props.children) {
            return React.cloneElement(children, {
                tabIndex: '-1',
                id
            });
        }
        return (
            <span
                className="sr-only"
                tabIndex="-1"
                id={id}
            >
                {anchorLabel}
            </span>
        );
    }
}

export default SkipToContentMenuAnchorInner;